import _classCallCheck from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

var styles = function styles(theme) {
  return {
    root: {
      background: grey[100],
      // width: 200,
      margin: theme.spacing.unit,
      // display: "inline-block",
      cursor: 'pointer'
    },
    caption: {
      display: "inline-block",
      margin: "0 ".concat(theme.spacing.unit, "px")
    }
  };
};

var DashboardCards =
/*#__PURE__*/
function (_Component) {
  _inherits(DashboardCards, _Component);

  function DashboardCards() {
    _classCallCheck(this, DashboardCards);

    return _possibleConstructorReturn(this, _getPrototypeOf(DashboardCards).apply(this, arguments));
  }

  _createClass(DashboardCards, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          title = _this$props.title,
          value = _this$props.value,
          list = _this$props.list,
          subtitle = _this$props.subtitle,
          raised = _this$props.raised,
          color = _this$props.color;
      if (raised === undefined) raised = true;
      var backgroundColor;
      if (color !== undefined) backgroundColor = color;
      return React.createElement(Card, {
        raised: raised,
        className: classes.root,
        style: {
          backgroundColor: backgroundColor
        }
      }, React.createElement(CardHeader, {
        titleTypographyProps: {
          color: "primary",
          variant: "subtitle1"
        },
        title: title,
        subheader: subtitle
      }), React.createElement(CardContent, null, value !== undefined && React.createElement(Typography, {
        variant: "h2",
        color: "error",
        align: "right"
      }, value), list && list.map(function (item, idx) {
        return React.createElement(Typography, {
          variant: "h5",
          color: "error",
          align: "right",
          key: idx,
          style: {
            display: 'inline-block'
          }
        }, item.value, React.createElement(Typography, {
          variant: "caption",
          color: "textSecondary",
          className: classes.caption
        }, item.label));
      })));
    }
  }]);

  return DashboardCards;
}(Component);

DashboardCards.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.number,
  list: PropTypes.array,
  raised: PropTypes.bool
};
export default withStyles(styles, {
  withTheme: true
})(DashboardCards);